import React, { useRef, useState } from 'react';
import AudioUploadForm from './components/AudioUploadForm';
import { Link } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import styles from './UploadPage.module.scss';

const UploadPage = () => {
  const [passwordCorrect, setPasswordCorrect] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const formRef = useRef(null);
  const dragCounterRef = useRef(0);

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!formRef.current?.canAcceptDrop()) return;
    dragCounterRef.current += 1;
    setIsDragging(true);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dragCounterRef.current -= 1;
    if (dragCounterRef.current === 0) setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dragCounterRef.current = 0;
    setIsDragging(false);
    formRef.current?.selectFile(event.dataTransfer.files[0]);
  };

  return (
    <div>
      {!passwordCorrect ? (
        <LoginForm setPasswordCorrect={setPasswordCorrect} />
      ) : (
        <div
          className={[styles.page, isDragging && styles.isDragging].filter(Boolean).join(' ')}
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {isDragging && (
            <div className={styles.dropOverlay} aria-hidden='true'>
              <p>Drop to upload</p>
            </div>
          )}

          <Link to='/' className={styles.back}>
            ⬅ Home
          </Link>
          <h2 className={styles.title}>Upload Audio</h2>
          <p className={styles.subtitle}>Drag and drop an audio file anywhere on this page</p>
          <AudioUploadForm ref={formRef} />
        </div>
      )}
    </div>
  );
};

export default UploadPage;
